export const AUTH_CONFIG = {
  domain: 'rentlynetwork.auth0.com',
  clientId: 's9dmRw72Ch40GalR1mg0juG0gprXQ7Mm',
  callbackUrl: process.env.REACT_APP_AUTH_CALLBACK,
};
